<template>
  <div class="passwordetail">
    <navBack title="修改密码"></navBack>
    <div class="passwordetail_title">
      <p>修改密码</p>
    </div>
    <div class="passwordetail_form">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="原密码" prop="oldPassword">
          <el-input
            class="passwordetail_form__input"
            type="password"
            v-model="ruleForm.oldPassword"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            class="passwordetail_form__input"
            type="password"
            v-model="ruleForm.password"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="surePassword">
          <el-input
            class="passwordetail_form__input"
            type="password"
            v-model="ruleForm.surePassword"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button class="register_btn" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import navBack from "../../components/navBack.vue";
import { vaildate } from "../../utils/validate.js";
import { changePassword } from "../../api/moudles/user.js";
export default {
  data() {
    const isPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (!vaildate.isPassword(value)) {
        callback(new Error("密码长度不足6位"));
      } else if (!vaildate.CheckPassWord(value)) {
        callback(new Error("密码不符合规则"));
      } else if (this.ruleForm.surePassword) {
        if (value != this.ruleForm.surePassword) {
          callback(new Error("密码两次输入不一致"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const isCheckPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (!vaildate.isPassword(value)) {
        callback(new Error("密码长度不足6位"));
      } else if (!vaildate.CheckPassWord(value)) {
        callback(new Error("密码不符合规则"));
      } else if (value != this.ruleForm.password) {
        callback(new Error("密码两次输入不一致"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        oldPassword: "",
        password: "",
        surePassword: "",
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: "请输入原密码",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            validator: isPassword,
            trigger: "blur",
          },
        ],
        surePassword: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: "blur",
          },
          {
            validator: isCheckPassword,
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    navBack,
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    userInfo: (state) => state.user.userInfo,
  }),
  methods: {
    // 修改密码
    async changePassword() {
      await changePassword({
        data: {
          memberCode: this.userInfo.memberCode,
          oldPassword: this.ruleForm.oldPassword,
          newPassword: this.ruleForm.password,
        },
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: "密码修改成功，请重新登录!",
              type: "success",
            });
            setTimeout(() => {
              this.isLogin = false;
              this.userName = "用户";
              this.userHead = "";
              this.$store.commit("user/RESET_INFO");
              localStorage.removeItem("token");
              localStorage.removeItem("userName");
              localStorage.removeItem("userPhoto");
              this.$router.replace("/login");
            }, 1500);
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        },
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changePassword();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .passwordetail_title {
    display: none;
  }
  .passwordetail_form {
    width: 90%;
    margin-left: 5%;
    padding-top: 50px;
  }
  .register_btn {
    width: 350px;
    background-color: #c22c25;
    color: #fff;
    margin-left: -98px;
  }
  .passwordetail {
    height: 720px;
    background-color: #fff;
  }
}

@media screen and (min-width: 750px) {
  .passwordetail_form {
    width: 36%;
    margin-left: 28%;
    padding-top: 50px;
  }
  .passwordetail_form__input {
    width: 300px;
  }
  .register_btn {
    width: 300px;
    background-color: #c22c25;
    color: #fff;
  }
  .passwordetail {
    height: 650px;
    background-color: #fff;
  }
}

.passwordetail_title {
  height: 60px;
  font-weight: 500;
  font-size: 22px;
  line-height: 60px;
  padding-left: 20px;
  border-bottom: 1px solid #f2f2f2;
}
</style>
